<template>
  <li class="list-separated-item">
    <div class="row align-items-center">
      <div class="col-auto">
        <input
          type="checkbox"
          data-test="invoicing-group-list-item-radio"
          :id="`radio-${item.id}`"
          :name="`radio-${item.id}`"
          size="xl"
          class="details-radio"
          :value="item.id"
          :checked="isChecked"
          :disabled="isDisable"
          :title="isDisable ? 'Currency doesn\'t match campaign':''"
          @change="selectDetails()"
        >
      </div>
      <div class="col">
        <div
          class="text-inherit"
          v-if="item.alias"
        >
          {{ item.alias }}
        </div>
        <small>
          {{ item.contactFirstName }} {{ item.contactLastName }}
        </small>
        <small class="d-block item-except text-sm text-muted h-1x">{{ item.xeroContactId }}</small>
      </div>
      <div class="col-3">
        <small class="d-block item-except text-sm text-muted h-1x">{{ getCountry }}</small>
        <small class="d-block item-except text-sm text-muted h-1x">{{ getCurrency }}
        </small>
      </div>
    </div>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'InvoicingSelectionListItem',
  components: {
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selectedDetailsId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('campaigns', [
      'order',
      'currencies',
      'countries',
    ]),
    ...mapGetters('campaigns', {
      isCampaignReadonly: campaignTypes.GET_IS_CAMPAIGN_READONLY,
    }),
    getCurrency() {
      const currency = this.currencies
        .find((item) => (item.id === this.item.billingCurrencyId));
      return currency.symbolString;
    },
    getCountry() {
      return this.countries[this.item.countryId];
    },
    isChecked() {
      return this.item.id === this.selectedDetailsId;
    },
    isDisable() {
      return !(this.item.billingCurrencyId === this.order.currencyId) || this.isCampaignReadonly;
    },
  },
  methods: {
    selectDetails() {
      this.$emit('updateSelection', this.isChecked ? null : this.item.id);
    },
  },
  created() {
  },
};
</script>
<style lang="scss">
.details-radio {
    min-height: 1.8rem;
  &.form-control-xl{
    font-size: 1.25rem;
    line-height: 1.5;
    padding-left: 1.5rem;
  }
  .custom-control-input {
    left: 0;
    z-index: -1;
    width: 1rem;
    height: 1.25rem;
    opacity: 0;
  }
  .custom-control-label::before {
    top: 0.20313rem;
    left: -1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  .custom-control-label::after {
    top: 0.20313rem;
    left: -1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  .custom-control-input:disabled ~ .custom-control-label::before {
    border: 1px solid transparent;
  }
  .custom-control-input:disabled ~ .custom-control-label {
    cursor: no-drop;
  }
}
</style>
